<!--
  - Copyright (c) 2019 Eva Novotná, Juraj Šimon
  -->

<template>
  <div ref="topbar">
    <div :class="topStyle">
      <div class="top-title-bar-inside">
        <div class="top-bar-label-wrapper">
          <div class="label">
            Eva Novotná
          </div>
          <transition name="fade">
            <div v-if="activeSection" class="section-name-mobile">
              {{ activeSectionName }}
            </div>
          </transition>
        </div>
        <div class="spacer"></div>
        <transition name="fade">
          <div v-if="activeSection" class="section-name">
            {{ activeSectionName }}
          </div>
        </transition>
        <div class="right-placeholder">
          <div
            class="lang-switcher"
            :title="$t('Switch language')"
            @click="switchLanguage"
          >
            {{ locale }}
          </div>
        </div>
      </div>
      <div ref="scroll-indicator" class="scroll-indicator"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      topStyle: {
        "top-title-bar": true,
        floating: false
      },
      width: null
    };
  },
  computed: {
    locale() {
      return this.$root.$i18n.locale;
    },
    ...mapGetters({
      activeSection: "home/activeSection"
    }),
    activeSectionName() {
      if (this.activeSection === "about") {
        return this.$t("about me");
      } else if (this.activeSection === "whatido") {
        return this.$t("what i do");
      }
      return "";
    }
  },
  methods: {
    switchLanguage() {
      if (this.$root.$i18n.locale === "en") {
        this.$root.$i18n.locale = "cs";
        localStorage.setItem("language", "cs");
      } else {
        this.$root.$i18n.locale = "en";
        localStorage.setItem("language", "en");
      }
      console.log("Language switched to ", this.$root.$i18n.locale);
    },
    handleScroll() {
      let dim = this.$refs.topbar.getBoundingClientRect();
      if (dim.y < 72) {
        this.topStyle.floating = true;
      } else {
        this.topStyle.floating = false;
      }
      let winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;
      let height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      let scrolled = (winScroll / height) * 100;
      this.$refs["scroll-indicator"].style.width = scrolled + "%";
    }
  },
  mounted() {
    this.width = this.$refs.topbar.offsetWidth;
    this.handleScroll();
    console.log("top bar mounted");
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style lang="scss" scoped>
@import "./../styles/main";

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: 0.5s;
}

.spacer {
  flex-grow: 1;
}

.scroll-indicator {
  width: 100%;
  height: 4px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #007eff59;
  z-index: 2;
}

.right-placeholder {
  padding: 0 $general-padding-on-sides - 1rem 0 1rem;
  height: 6rem;
  display: flex;
  align-items: center;

  @include mobile {
    padding: 0;
    margin: 0 $general-padding-on-sides-mobile 0 0;
  }
}

.lang-switcher {
  font-size: 1.5rem;
  padding: 1rem;
  min-width: 4.2rem;
  cursor: pointer;
  color: #00000073;
  text-transform: uppercase;
  border-radius: 10rem;
  transition: background-color 400ms;

  &:hover {
    background-color: #007eff59;
    color: #000000aa;
  }

  @include mobile {
    font-size: 1.5rem;
    line-height: 1.5rem;
  }
}

.section-name {
  padding-right: 1rem;
  text-transform: uppercase;
  font-size: 2rem;
  line-height: 2rem;

  @include mobile {
    display: none;
  }
}

.section-name-mobile {
  display: none;
  text-transform: uppercase;
  margin: 0 0 0 $general-padding-on-sides-mobile;

  @include mobile {
    display: block;
  }
}

$transition-speed: 0.3s;

.top-title-bar {
  position: absolute;
  display: flex;
  align-items: center;
  width: calc(100vw - (100vw - 100%));
  bottom: 0;
  height: 6rem;
  left: 0;
  background-color: $toolbar-background-color;
  z-index: 100;
  transition: $transition-speed;

  .top-title-bar-inside {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    flex-direction: row;
  }

  .top-bar-label-wrapper {
    @include mobile {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .label {
      @extend .poppins;
      font-size: $top-toolbar-font-size;
      line-height: $top-toolbar-font-size;
      margin: 0 0 0 $general-padding-on-sides;
      transition: $transition-speed;
      padding: 1rem 0 1rem 0;

      @include mobile {
        font-size: 2.5rem;
        line-height: 2.5rem;
        margin: 0 0 0 $general-padding-on-sides-mobile;
        padding: 0;
      }
    }
  }

  &.floating {
    position: fixed;
    top: 0;
    left: 0;
    height: 5rem;
    background-color: $toolbar-background-color-floating;
    transition: $transition-speed;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px,
      rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;

    .right-placeholder {
      height: 5rem;
    }

    .label {
      @extend .poppins;
      font-size: $top-toolbar-floating-font-size;
      line-height: $top-toolbar-floating-font-size;
      transition: $transition-speed;

      @include mobile {
        font-size: 2rem;
        line-height: 2rem;
        margin: 0 0 0 $general-padding-on-sides-mobile;
      }
    }
  }
}
</style>
